import React from 'react'
import { LegalAgreementsListingTabsContainer, LegalAgreementsTabButton } from './styledComponents'

export default function LegalAgreementsListingTabs() {
  return (
    <LegalAgreementsListingTabsContainer>
      <LegalAgreementsTabButton>Agreements</LegalAgreementsTabButton>
    </LegalAgreementsListingTabsContainer>
  )
}
